import { ISolicitation, IBasicData } from './../../shared/models/solicitation-models/solicitation/SolicitationModel';
import { Component, OnInit, QueryList } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { CatalogService } from './../../shared/services/catalogs/catalog.service';
import { CopyService } from './../../shared/services/copies/copy.service';
import { RequestSolicitationsService } from '../../shared/services/solicitations/request-solicitations.service';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/es-CO'
import { ApplicationService } from '../../shared/services/application/application.service';
import { BaseComponent } from '../../shared/components/base-component';
import { LinkupService } from '../../shared/services/link-up/linkup.service';
import { getValueProperty, scrollTop, setValueProperty } from '../../shared/helpers/functions.helpers';
registerLocaleData(localeFr, 'es');
import { getValueProperty as getValue } from '../../shared/helpers/functions.helpers';
import { camelCase } from 'lodash';
import { EVENT } from '../../shared/constants/dali.constants';

@Component({
  selector: 'app-radication-complete',
  templateUrl: './radication-complete.component.html',
  styleUrls: ['./radication-complete.component.scss'],
})
export class RadicationCompleteComponent extends BaseComponent implements OnInit {

  /**
   * Almacena los datos digitados por el cliente en pasos anteriores
   */
  solicitationData: ISolicitation = {};

  CONTENT_BOUNDS: any[] | any;

  stepsList: string[] = [];
  documentTypeList: any[] = [];
  citiesList: any[] = [];
  statesList: any[] = [];
  segmentsList: any[] = [];

  displayedColumnsInformation: string[] = ['Fecha', 'Tipo', 'Subtipo', 'Celula', 'Valor'];

  displayedColumnsContacts: string[] = ["fullname", "phone_1", "phone_2", "state", "city", "email"];

  modalInfo: boolean = false;
  channel_visible: boolean = true;
  cities_list = this._catalog.cities;
  public customer: IBasicData | any = {};

  RADICATION_ID_CODE: any = this._solicitation.solicitationId;
  finantialsList: any;
  genderList: QueryList<any> | any;
  not_preset_gender: any;

  subsegmentList: Array<{ name: string, id: any, segmentId: any }> = [];
  customerTypesList: any[] = [];
  celulaTypesList: any[] = [];
  celulaSubtypesList: any[] = [];
  isErrorUpload: boolean = false;

  constructor(
    public _solicitation: RequestSolicitationsService,
    private cps: CopyService,
    private _catalog: CatalogService,
    public readonly app: ApplicationService,
    private link: LinkupService
  ) {
    super(app, link, 'radication-complete');
  }
  ngOnInit() {
    this.loadStaticValues().finally(() => {
      let setting = this.getSetting("analytics", "pageLoad", "");
      setValueProperty(setting, "visitor.client.elegibility", getValueProperty(this._solicitation, "solicitation.analyticsData.solicitation_type", ""));
      setValueProperty(setting, "custom.message", getValueProperty(this._solicitation, "solicitation.analyticsData.solicitation_subtype", ""));
      let word = camelCase(getValueProperty(this.solicitationData, "additionalData.Annotations", ""));
      if (word) {
        word = word[0].toUpperCase() + word.substring(1);
      }
      setValueProperty(setting, "custom.searchterm", word);
      setValueProperty(setting, "transaction.details.productcategory", setting.transaction.details.productcategory);
      setValueProperty(setting, "transaction.details.productdetails", getValueProperty(this._solicitation, "solicitation.analyticsData.customer_type", ""));
      setValueProperty(setting, "transaction.details.transactioninstitution", getValueProperty(this._solicitation, "solicitation.analyticsData.solicitation_cell", ""));
      super.onLoad().finally(() => {
        let eventSetting = this.getSetting("analytics", "trackEvent.e3", "");
        let pageSetting = this.getSetting("analytics", "pageLoad", "");
        let events = [
          {
            "name": "{EVENT.pv6E3setData.pv6E3transactionName.path}",
            "value": EVENT.pv6E3setData.pv6E3transactionName.value
          },
          {
            "name": "{EVENT.pv6E3setData.pv6E3transactionProductCategory.path}",
            "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
          }
        ];
        setValueProperty(eventSetting, "events", events);
        setValueProperty(eventSetting, "messageEvent", this._solicitation.solicitation.additionalData?.numberTrys);
        this.onEvent(eventSetting);
      });
    });
    this.loadData();
    scrollTop();
  }

  async loadStaticValues() {
    await super.loadStaticValues();
    this.CONTENT_BOUNDS = await this.cps.getCopy("radication-complete");
    this.stepsList = await this.cps.getCopy("stepList");
    this.citiesList = await this._catalog.cities;
    this.statesList = await this._catalog.states;
    this.segmentsList = await this._catalog.segments;
    this.customer = this._solicitation.solicitation.basicData;
    this.finantialsList = await this._catalog.economicActivities;
    this.genderList = await this._catalog.genders;
    this.not_preset_gender = getValueProperty(this, "not_preset_gender", this.CONTENT_BOUNDS.not_preset_gender);
    this.citiesList = await this._catalog.cities;
    this.documentTypeList = await this._catalog.documentTypes;
    this.subsegmentList = await this._catalog.getSubsegments();
    this.customerTypesList = await this._catalog.customerTypes;
    this.celulaTypesList = await this._catalog.getCelulaTypes();
  }

  async loadData() {
    this.solicitationData = this._solicitation.solicitation;
    this.isErrorUpload = getValueProperty(this.solicitationData, 'additionalData.errorUpload', false);
    if (getValueProperty(this.solicitationData, 'additionalData.SolicitationType') && getValueProperty(this.solicitationData, 'additionalData.SolicitationSubtype')) {
      this.celulaSubtypesList = await this._catalog.getCelulaTypeSubtypes(getValueProperty(this.solicitationData, 'additionalData.Cell.id'), getValueProperty(this.solicitationData, 'additionalData.SolicitationType'));
    }
  }

  async onCloseEvent($event: any) {
    console.log('close event', $event);
  }

  async navigateTo(start: any) {
    if (start == "next") {
      this._solicitation.solicitation = {} as ISolicitation;
      this._catalog.clearCache();
      await this._solicitation.navigation.nextStep();
      let eventSetting = this.getSetting("analytics", "trackEvent.e1", "");
      let pageSetting = this.getSetting("analytics", "pageLoad", "");
      let events = [
        {
          "name": "{EVENT.pv6E1setData.pv6E1transactionName.path}",
          "value": EVENT.pv6E1setData.pv6E1transactionName.value
        },
        {
          "name": "{EVENT.pv6E1setData.pv6E1transactionProductCategory.path}",
          "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
        }
      ];
      setValueProperty(eventSetting, "events", events);
      this.onEvent(eventSetting);
    }
    else {
      this._solicitation.navigation.startFlow("solicitationSearch");
      let eventSetting = this.getSetting("analytics", "trackEvent.e2", "");
      let pageSetting = this.getSetting("analytics", "pageLoad", "");
      let events = [
        {
          "name": "{EVENT.pv6E2setData.pv6E2transactionName.path}",
          "value": EVENT.pv6E2setData.pv6E2transactionName.value
        },
        {
          "name": "{EVENT.pv6E2setData.pv6E2transactionProductCategory.path}",
          "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
        }
      ];
      setValueProperty(eventSetting, "events", events);
      this.onEvent(eventSetting);
    }
  }

  /**
     * Permite obtener el valor de una propiedad del objeto pasado por parametro
     * @param object
     * @param property
     */
  getValueProperty(object: any, property: string | number, defecto?: any) {
    return getValue(object, property, defecto);
  }

  async downloadFile(file: File) {
    const arrayBuffer = await file.arrayBuffer();
    const fileName = file.name;
    const a = document.createElement('a')
    a.href = URL.createObjectURL(new Blob(
      [arrayBuffer],
      { type: file.type }
    ))
    a.download = fileName
    a.click();
    a.remove();
  }

  async processAction(action: any, parameters: any = '') {
    const method = getValueProperty(this, action);
    let context: any = this;
    if ( action && typeof(method) == "function") {
      context[action](parameters);
    }
  }
}
